// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ContainersIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 30 33">
    <path
      fill="url(#containers_svga)"
      d="M14.98 27.9 2.7 18.35 0 20.45l15 11.67 15-11.67-2.72-2.12zm.02-4.23 12.27-9.55L30 12 15 .33 0 12l2.72 2.12z"
    />
    <defs>
      <linearGradient
        id="containers_svga"
        x1={0}
        x2={32.42}
        y1={0.33}
        y2={29.42}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E45E2" />
        <stop offset={1} stopColor="#A22E95" />
      </linearGradient>
    </defs>
  </svg>,
  "Containers",
);
export default ContainersIcon;
